import classNames from 'classnames';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';

import { BurgerMenu } from '@zooplus/icons';

import AppContext from '../../context';
import { BURGER_PANEL_PORTAL } from '../../utils/constants';
import BurgerNavigation from '../BurgerNavigation';

import styles from './MobileBurgerButton.module.scss';

export type MobileBurgerButtonProps = {
    label?: string;
    id?: string;
    className?: string;
};

const MobileBurgerButton = ({
    label,
    id,
    className,
}: MobileBurgerButtonProps): JSX.Element => {
    const { showCategories, translations } = useContext(AppContext);
    const [burgerNav, setBurgerNav] = useState(false);
    const [isClientSide, setClientSide] = useState(false);
    const burgerButtonRef = useRef<HTMLButtonElement>(null);

    /* Require below code to ensure on navigation panel activation background does not scroll */
    useEffect(() => {
        if (document && document.body) {
            document.body.style.overflow = burgerNav ? 'hidden' : '';
        }
        setClientSide(true);
    }, [burgerNav]);

    const handleClick = () => {
        // When the state is set to false, it must be close event,
        // hence bring back focus hamburger btn
        if (burgerNav && burgerButtonRef.current) {
            burgerButtonRef.current.focus();
        }
        setBurgerNav(!burgerNav);
    };

    return (
        <>
            <button
                type="button"
                className={classNames(className, styles.hamburger)}
                data-zta="hamburger-button"
                id={id}
                ref={burgerButtonRef}
                onClick={handleClick}
                aria-expanded={burgerNav}
                aria-label={label}>
                <BurgerMenu
                    className={styles.hamburgerBox}
                    aria-label={translations.get(
                        'shop.header.accessible.catalog.menu',
                    )}
                />
                <div className={styles.accessibleText}>{label}</div>
            </button>
            {isClientSide &&
                showCategories &&
                createPortal(
                    <BurgerNavigation
                        handleCloseClick={handleClick}
                        open={burgerNav}
                    />,
                    document.getElementById(BURGER_PANEL_PORTAL) ||
                        document.body,
                )}
        </>
    );
};

export default MobileBurgerButton;
